import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import ErrorBoundary from './components/shared/ErrorBoundary';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import BackgroundShapes from './components/layout/BackgroundShapes';
import ScrollToTop from './components/shared/ScrollToTop';
import AIChatbot from './components/shared/AIChatbot';
import CookieConsent from './components/common/CookieConsent';
import Home from './pages/Home';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import ProfilePage from './pages/ProfilePage';
import CoursesPage from './pages/CoursesPage';
import StoryBooksPage from './pages/StoryBooksPage';
import StorybookViewerPage from './pages/StorybookViewerPage';
import CourseDetailPage from './pages/CourseDetailPage';
import CourseViewerPage from './pages/CourseViewerPage';
import AdminPage from './pages/AdminPage';
import PlatformPage from './pages/PlatformPage';
import PricingPage from './pages/PricingPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentFailurePage from './pages/PaymentFailurePage';
import ManualPaymentRequestPage from './pages/ManualPaymentRequestPage';
import PurchasesPage from './pages/PurchasesPage';
import BundlesPage from './pages/BundlesPage';
import ManualPaymentsPage from './pages/ManualPaymentsPage';
import MyContentPage from './pages/MyContentPage';
import NotificationsPage from './pages/NotificationsPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <Router>
            <div className="relative min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300 overflow-x-hidden max-w-full">
              <BackgroundShapes />
              <Header />
              <main className="relative z-10">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/privacy" element={<PrivacyPage />} />
                  <Route path="/terms" element={<TermsPage />} />
                  <Route path="/pricing" element={<PricingPage />} />
                  <Route path="/platform" element={<PlatformPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                  <Route path="/reset-password" element={<ResetPasswordPage />} />
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/my-content" element={<MyContentPage />} />
                  <Route path="/purchases" element={<PurchasesPage />} />
                  <Route path="/bundles" element={<BundlesPage />} />
                  <Route path="/manual-payments" element={<ManualPaymentsPage />} />
                  <Route path="/notifications" element={<NotificationsPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                <Route path="/courses" element={<CoursesPage />} />
                <Route path="/storybooks" element={<StoryBooksPage />} />
                <Route path="/storybook/:slug" element={<StorybookViewerPage />} />
                <Route path="/course/:id" element={<CourseDetailPage />} />
                <Route path="/course/:id/view" element={<CourseViewerPage />} />
                  <Route path="/admin" element={<AdminPage />} />
                  <Route path="/payment/success" element={<PaymentSuccessPage />} />
                  <Route path="/payment/failure" element={<PaymentFailurePage />} />
                  <Route path="/manual-payment/:id" element={<ManualPaymentRequestPage />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </main>
              <Footer />
              <AIChatbot />
              <CookieConsent />
              <ScrollToTop />
            </div>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
